import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.find";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import { isNullOrEmpty } from '../../../../../../utils/vuex';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import isObject from 'lodash/isObject';
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';

var getDeviceVariables = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(deviceId, deviceTypeId) {
    var parser;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return NiotaClassicApiService.deviceTypeGetDetails(deviceTypeId).then(function (res) {
              var parser = get(res, 'data.devicetype.parser.config.variables') || {};

              if (get(res, 'data.devicetype.parser.type') === 'multi') {
                parser = {};
                var parserKeys = Object.keys(get(res, 'data.devicetype.parser.config') || {}).filter(function (k) {
                  return k !== '__switch';
                });
                parserKeys.forEach(function (pKey) {
                  if (isObject(get(res, "data.devicetype.parser.config.".concat(pKey, ".variables")))) {
                    parser = _objectSpread(_objectSpread({}, parser), get(res, "data.devicetype.parser.config.".concat(pKey, ".variables")) || {});
                  }
                });
              }
              /* 
              ORIGIN: {
                "temperature": {
                  "name": "temperature",
                  "value_type": { // << MUST BE FILLED!
                    "name": "°C"
                  }
                }
              }
              TARGET: {
                "temperature": {
                  "time": "2019-05-28T14:17:36.000Z",
                  "value": 29.75,
                  "value_type_name": "°C",
                  "variable": "temperature"
                }
              } */


              Object.keys(parser).forEach(function (parserKey) {
                if (!parser[parserKey]['value_type']) {
                  delete parser[parserKey];
                } else {
                  parser[parserKey].variable = parserKey;
                  parser[parserKey].value_type_name = // prefer to use the base-unit, as the value will be converted to that
                  get(parser, "".concat(parserKey, ".value_type.base_unit")) || get(parser, "".concat(parserKey, ".value_type.name"));
                  parser[parserKey].value = 'N/A';
                }
              });
              return parser;
            }).catch(function () {
              return null;
            });

          case 2:
            parser = _context.sent;

            if (!parser) {
              parser = {};
            }

            return _context.abrupt("return", parser);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getDeviceVariables(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export default {
  name: 'CoreDtwinStateIothubAggregateEdit',
  components: {
    codemirror: codemirror
  },
  props: {
    // the current edited binding
    lclModel: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    tenantId: {
      type: Number,
      required: true
    },
    // is this an 'edit', 'create', or mass-variable- 'import'?
    mode: {
      type: String,
      required: false,
      default: function _default() {
        return 'edit';
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      // the current result-set for the autocomplete device search
      niotaDevices: [],
      loadingDevices: false,
      niotaDeviceSearch: '',
      selectedNiotaDevice: null,
      aggregateStateValue: '',
      niotaDeviceVariableHeaders: [{
        sortable: true,
        text: 'Name',
        value: 'variable',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.value'),
        value: 'value',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.lastUpdate'),
        value: 'milliseconds_ago',
        align: 'left'
      }, {
        sortable: true,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.unit'),
        value: 'value_type_name',
        align: 'left'
      }],
      niotaDeviceVariableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [20, 50, {
          text: this.$i18n_t('Common.all'),
          value: -1
        }]
      },
      // the retrieved variables for the selected device
      niotaDeviceVariables: null,
      selectedNiotaDeviceVariable: [],
      cmOptions: {
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: false,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        readOnly: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: false
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    hasManageAllPermissions: function hasManageAllPermissions() {
      return this.permissions['all.manage'];
    },
    formIsValid: function formIsValid() {
      return !isNullOrEmpty(this.selectedNiotaDevice) && !isNullOrEmpty(this.selectedNiotaDeviceVariable) && this.selectedNiotaDeviceVariable.length > 0;
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    }
  }),
  watch: {
    niotaDeviceSearch: function niotaDeviceSearch(val) {
      if (!val || val.length < 2) {
        // if search value is empty or less than two characters do not start a search
        // but treat the old search as invalid as a new search is as about to happen
        // in this state no results will be shown in the auto-complete dropdown
        // because we set `niotaDevices` to an array with only `selectedNiotaDevice`
        // which will not show up because auto-completes `hide-selected` is true
        // while `loadingDevices` is true or the search is empty or less than two characters
        this.niotaDevices = [this.selectedNiotaDevice].filter(function (d) {
          return d;
        });
        return;
      } // do not trigger the device-search (again) after the item has been selected
      // that would clear the variable-set


      if (!this.selectedNiotaDevice || !this.selectedNiotaDevice.title || val !== this.selectedNiotaDevice.title) {
        // set loadingDevices to true as early as the debounced fetchDevices will be called
        // to not delay the loading state when settings it from the debounced method
        this.loadingDevices = true;
        this.fetchDevices();
      }
    },
    selectedNiotaDevice: function selectedNiotaDevice(val) {
      if (val !== null) {
        this.fetchVariables();
      }

      this.emitSelection();
    },
    selectedNiotaDeviceVariable: function selectedNiotaDeviceVariable() {
      this.emitSelection();
    }
  },
  created: function created() {
    var _this2 = this;

    if (this.mode !== 'create' && this.mode !== 'import' && this.lclModel.properties.binding.options.identifier) {
      NiotaClassicApiService.deviceGetDetails(this.lclModel.properties.binding.options.identifier).then(function (res) {
        var device = get(res, 'data.device');

        if (!device || !device.id) {
          throw new Error('NIOTA_DEVICE_NOT_FOUND');
        }

        _this2.niotaDevices = device ? [device] : null;
        _this2.selectedNiotaDevice = device;
      }).catch(function (error) {
        console.error(get(error, 'response.status'));

        if (get(error, 'response.status') === 403) {
          // user has no permission to read the device
          // probably some other user linked it, and this user cannot read it
          // so emit the no-permission event here to trigger the edit-dialog to be closed
          _this2.$emit('no-permission', _this2.$i18n_t('DigitalTwin.DigitalTwin.states.noPermissionError'));

          return;
        }

        console.error(error);
        var errorMessage = get(error, 'response.data.message', error.message);
        var errorOutput = _this2.$i18n_te("Error.".concat(errorMessage)) ? _this2.$i18n_t("Error.".concat(errorMessage)) : _this2.$i18n_t(errorMessage);

        _this2.$snack(errorOutput, 'error');

        _this2.niotaDevices = null;
        _this2.selectedNiotaDevice = null;
      }).finally(function () {
        _this2.loading = false;
      });
      this.selectedNiotaDeviceVariable = (this.lclModel.properties.binding.options.variable || []).map(function (aggVar) {
        return {
          variable: aggVar
        };
      });
    }
  },
  methods: {
    isNullOrEmpty: isNullOrEmpty,
    refreshForm: function refreshForm() {
      var _this3 = this;

      setTimeout(function () {
        if (_this3.$refs.codemirror) {
          // required workaround to get the cursor appearing at the right spot
          // https://discuss.codemirror.net/t/codemirror-cursor-is-not-partially-visible/648/6
          _this3.$refs.codemirror.codemirror.refresh();

          _this3.$refs.codemirror.codemirror.focus();
        }
      }, 50);
    },
    emitSelection: function emitSelection() {
      this.$emit('bridge-binding-changed', {
        valueType: get(this.selectedNiotaDeviceVariable, '[0].value_type_name'),
        variable: get(this.selectedNiotaDeviceVariable, '[0].variable)'),
        value: get(this.selectedNiotaDeviceVariable, '[0].value')
      });
      var aggregateStateValue = {};
      this.selectedNiotaDeviceVariable.forEach(function (aggVar) {
        aggregateStateValue[aggVar.variable] = aggVar.value;
      });
      this.aggregateStateValue = aggregateStateValue;
    },
    fetchDevices: debounce(function () {
      var _this4 = this;

      this.loadingDevices = true;
      NiotaClassicApiService.devicesFind(this.niotaDeviceSearch, 0, 50, 'title', 'ASC').then(function (res) {
        // only allow devices with a devicetype, as otherwise there are no parsed variables to choose from
        _this4.niotaDevices = get(res, 'data.devices', []).filter(function (device) {
          return device.deviceTypeId;
        });
      }).catch(function (error) {
        console.error(error);
        var errorMessage = get(error, 'response.data.message', error.message);
        var errorOutput = _this4.$i18n_te("Error.".concat(errorMessage)) ? _this4.$i18n_t("Error.".concat(errorMessage)) : _this4.$i18n_t(errorMessage);

        _this4.$snack(errorOutput, 'error');

        _this4.niotaDevices = [];
      }).finally(function () {
        _this4.loadingDevices = false;
      });
    }, 250),
    fetchVariables: function fetchVariables() {
      var _this5 = this;

      this.niotaDeviceVariables = null;

      if (!get(this, 'selectedNiotaDevice.id') || !get(this, 'selectedNiotaDevice.deviceTypeId')) {
        return;
      }

      getDeviceVariables(this.selectedNiotaDevice.id, this.selectedNiotaDevice.deviceTypeId).then(function (variables) {
        var variableKeys = Object.keys(variables);
        _this5.niotaDeviceVariables = variableKeys.map(function (key) {
          var variable = variables[key];

          if (variable.time) {
            variable['milliseconds_ago'] = new Date() - new Date(variable.time);
            variable['time_ago'] = variable['milliseconds_ago'];
            var units = ['seconds', 'minutes', 'hours', 'days', 'months'];
            var conversion = [1000, 60, 60, 24, 30];
            var selectedUnit = 0;

            while (variable['time_ago'] >= conversion[selectedUnit] && selectedUnit < conversion.length) {
              variable['time_ago'] = Math.floor(variable['time_ago'] / conversion[selectedUnit]);
              selectedUnit++;
            }

            selectedUnit--;
            variable['time_ago'] = "".concat(variable['time_ago'], " ").concat(units[selectedUnit]);
          }

          return variable;
        });
        _this5.selectedNiotaDeviceVariable = (_this5.lclModel.properties.binding.options.variable || []).map(function (aggVar) {
          var match = _this5.niotaDeviceVariables.find(function (dVar) {
            return dVar.variable === aggVar;
          });

          if (match) {
            return match;
          }

          return {
            variable: aggVar
          };
        });
      }).catch(function (error) {
        console.error(error);
        var errorMessage = get(error, 'response.data.message', error.message);
        var errorOutput = _this5.$i18n_te("Error.".concat(errorMessage)) ? _this5.$i18n_t("Error.".concat(errorMessage)) : _this5.$i18n_t(errorMessage);

        _this5.$snack(errorOutput, 'error');

        _this5.niotaDeviceVariables = [];
      });
    },
    saveState: function saveState() {
      this.lclModel.properties.binding.options.identifier = get(this.selectedNiotaDevice, 'id');
      this.lclModel.properties.binding.options.variable = this.selectedNiotaDeviceVariable.map(function (v) {
        return v.variable;
      });
    }
  }
};